var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 25,
    y: 51
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 25,
    y: 47
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 25,
    y: 43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,28h-2c0,1.103-0.897,2-2,2s-2-0.897-2-2h-2c0,2.206,1.794,4,4,4S26,30.206,26,28z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 22,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 22,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,47h-5v-1c0-0.552,0.448-1,1-1h2c1.654,0,3-1.346,3-3v-1h-2v1c0,0.552-0.448,1-1,1h-2c-1.654,0-3,1.346-3,3v1h-5   c-2.757,0-5,2.243-5,5v1.828c0,2.646,1.982,4.907,4.513,5.148c1.403,0.137,2.81-0.33,3.85-1.275c0.79-0.719,1.325-1.67,1.536-2.701   h2.203c0.211,1.031,0.746,1.982,1.536,2.701C49.56,58.539,50.768,59,52.01,59c0.159,0,0.318-0.008,0.478-0.023   C55.018,58.735,57,56.475,57,53.828V52C57,49.243,54.757,47,52,47z M55,53.828c0,1.626-1.187,3.014-2.702,3.158   c-0.864,0.074-1.683-0.189-2.315-0.766C49.358,55.653,49,54.844,49,54v-1h-6v1c0,0.844-0.358,1.653-0.982,2.221   c-0.633,0.576-1.449,0.839-2.315,0.766C38.187,56.842,37,55.454,37,53.828V52c0-1.654,1.346-3,3-3h12c1.654,0,3,1.346,3,3V53.828z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 51,
    y: 51
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 39,
    y: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,37h-7.713L41,31.195V37h-7c-1.232,0-2.347,0.465-3.219,1.207L28,37.279v-2.072c2.495-1.631,4.283-4.246,4.822-7.291   c2.299-0.384,4.061-2.333,4.158-4.716C37.08,22.788,38,18.805,38,12v-1.388l-3.274,1.092c-1.909-7.498-6.119-9.525-6.306-9.611   l-0.862-0.399l-0.986,1.873C24.805,2.604,20.573,1,12,1h-1.281l0.928,3.71L6.836,3.747l0.991,7.929L4,10.719V12   c0,6.39,2.382,10.387,3.037,11.366c0.17,2.295,1.878,4.158,4.141,4.547c0.537,3.046,2.326,5.662,4.822,7.294v2.072L5.786,40.685   C2.924,41.638,1,44.307,1,47.324V57h28v1c0,2.757,2.243,5,5,5h24c2.757,0,5-2.243,5-5V42C63,39.243,60.757,37,58,37z M33,25.816   v-5.631c1.161,0.414,2,1.514,2,2.816S34.161,25.402,33,25.816z M10.173,14.324L9.164,6.253l5.189,1.037l-1.069-4.277   c9.985,0.2,12.961,2.702,12.98,2.719l0.956,0.893l1.147-2.177c1.225,0.984,3.546,3.474,4.653,8.758l0.229,1.099l2.735-0.912   c-0.05,2.515-0.229,4.573-0.418,6.116c-0.686-0.701-1.572-1.203-2.568-1.407V16h-2v1.982c-3.345-0.139-6.607-1.113-9.485-2.84   L20,14.233V16c0,0.873,0.123,1.748,0.362,2.589c-2.535-0.684-4.957-1.712-7.22-3.069L11,14.233v3.868   c-1.393,0.284-2.562,1.158-3.272,2.339c-0.699-1.551-1.512-3.979-1.692-7.15L10.173,14.324z M9,23c0-1.302,0.839-2.402,2-2.816   v5.631C9.839,25.402,9,24.302,9,23z M13,26v-8.254c2.752,1.528,5.709,2.615,8.804,3.234l2.005,0.401l-1.02-2.04   c-0.246-0.492-0.437-1.012-0.569-1.546c2.74,1.326,5.73,2.073,8.78,2.188V26c0,4.963-4.037,9-9,9S13,30.963,13,26z M22,37   c1.412,0,2.758-0.277,4-0.764v1.637l-0.001,0.004C25.541,39.716,23.896,41,22,41c-1.894,0-3.539-1.283-4-3.124v-1.64   C19.242,36.723,20.588,37,22,37z M11,55v-8H9v8H3v-7.676c0-2.155,1.374-4.062,3.419-4.743l9.949-3.316   c0.816,1.932,2.564,3.311,4.632,3.651V53h2V42.916c2.069-0.34,3.817-1.719,4.632-3.651l1.855,0.619C29.183,40.528,29,41.241,29,42   v13H11z M61,58c0,1.654-1.346,3-3,3H34c-1.654,0-3-1.346-3-3V42c0-1.654,1.346-3,3-3h9v-4.195L49.713,39H58c1.654,0,3,1.346,3,3V58   z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClient);
export default __webpack_public_path__ + "static/media/Ic_client.5467333880581648c645e60fb61b60b8.svg";
export { ForwardRef as ReactComponent };